export const getCallMembershipPresence = (mxUserId, memberships) => {
    const remoteMemberCount = memberships.filter((membership) => (membership.userId || membership.sender) !== mxUserId).length;
    const hasSelfMember = memberships.some((membership) => (membership.userId || membership.sender) === mxUserId);
    return { hasSelfMember, remoteMemberCount };
};
export const isIncomingCallActive = (mxUserId, memberships) => {
    const { hasSelfMember, remoteMemberCount } = getCallMembershipPresence(mxUserId, memberships);
    return remoteMemberCount > 0 && !hasSelfMember;
};
export const isCallActive = (mxUserId, memberships) => {
    const { hasSelfMember, remoteMemberCount } = getCallMembershipPresence(mxUserId, memberships);
    return hasSelfMember && remoteMemberCount > 0;
};
export const isOutgoingCallPending = (mxUserId, memberships) => {
    const { hasSelfMember, remoteMemberCount } = getCallMembershipPresence(mxUserId, memberships);
    return hasSelfMember && remoteMemberCount === 0;
};
export const getRemoteRtcMemberUserIds = (mxUserId, memberships) => {
    return new Set(memberships
        .map((membership) => membership.userId || membership.sender)
        .filter((userId) => !!userId && userId !== mxUserId));
};
//# sourceMappingURL=callMembershipState.js.map